<template>
	<div class="color-picker container">
		<div class="wrapper-dropdown" v-on-click-outside="hideStatus">
			<span @click="toggleDropdown()" class="dropdown__holder" :class="data.class" v-html="data.statusName">
				<span>
					{{ data.statusName }}
				</span>
			</span>
			<transition name="fade">
				<ul class="dropdown" v-show="active">
					<li class="color-picker__item" v-for="color in data.times" @click="setColor(color.hex, color.name, color.date)" :key="color.name">
						<span :style="{background: color.hex}">
						</span> {{color.name}}
						<span class="color-picker__item-date">{{ color.date }}</span>
					</li>
				</ul>
			</transition>
		</div>
	</div>
</template>

<script>
import { mixin as onClickOutside } from 'vue-on-click-outside';
export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data () {
		return { 
			active: false
		};
	},
	computed: {
		selector: function() {
			if (!this.selectedColor) {
				return 'Frame';
			} else {
				return '<span style="background: ' + this.selectedColor + '"></span> ' + this.selectedColorName;
			}
		}
	},
	mixins: [onClickOutside],
	methods: {
		setColor: function(color, colorName) {
			this.selectedColor = color;
			this.selectedColorName = colorName;
			this.active = false;
		},
		toggleDropdown: function() {
			this.active = !this.active;
		},
		hideStatus() {
			this.active = false;
		}
	}
};
</script>
<style lang="scss" scoped>
.dropdown {
    padding: 15px;
	transition: $dur $ease;
	width: 305px;
	position: absolute;
    background: $white;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 8px !important;
	z-index: 1001;

	@include mq($lg) {
		width: fit-content;
	}
}

.color-picker__item {
    display: flex;
    align-items: center;
    margin-bottom: 2px;
    font-family: $font-main;
    font-size: 14px;
    line-height: 1.2;
    color: $fiord;
    margin-bottom: 10px;

    span {
        width: 12px;
        height: 12px;
        display: block;
        border-radius: 50%;
        margin-right: 18px;
    }
}

.color-picker__item-date {
    font-family: $font-main;
    font-size: 14px;
    line-height: 1.2;
    color: $shuttle-gray;
    opacity: 0.5;
    padding: 0 10px 7px;
}

.dropdown__holder {
	padding: 3px 27px 3px 10px;
	cursor: pointer;
	position: relative;
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	max-width: 140px;
	min-width: 80px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: block;
	transition: $dur $ease;
	border-radius: 8px;
	color: $white;

	@include mq(440px) {
		min-width: 65px;
		padding: 3px 20px 3px 10px;
	}

	&::after,
	&::before {
		border-right: 2px solid;
		content: '';
		display: block;
		height: 5px;
		margin-top: -4px;
		position: absolute;
		transform: rotate(135deg);
		right: 10px;
		top: 46%;
		width: 0;
	}

	&::after {
		margin-top: -1px;
		transform: rotate(45deg);
	}
}
</style>
